export const SIDE_NAV_WIDTH = 80

/**
 * Icon rail navigation. `match` lists the path prefixes that mark the item
 * as active. Icons are Tabler icons.
 */
export const NAV_ITEMS = [
  {
    id: 'home',
    label: 'Home',
    icon: 'tabler:home',
    to: '/',
    match: [''],
  },
  {
    id: 'paths',
    label: 'Paths',
    icon: 'tabler:route',
    to: '/collections',
    match: ['collections', 'collection', 'collection-builder'],
  },
  {
    id: 'courses',
    label: 'Courses',
    icon: 'tabler:book-2',
    to: '/courses',
    match: [
      'courses',
      'mini-course',
      'create-course-selection',
      'create-course',
      'create-course-with-ai',
      'create-course-with-ai-use-docs',
      'ai-course-creation',
    ],
  },
  {
    id: 'portal',
    label: 'Portal',
    icon: 'tabler:world',
    // The portal is the workspace "showcase" collection; its id is resolved
    // on click (see SideNav).
    opensShowcase: true,
    match: [],
  },
  {
    id: 'connect',
    label: 'Connect',
    tooltip: 'Connect Claude, ChatGPT or Manus',
    icon: 'tabler:plug-connected',
    to: '/connect',
    match: ['connect'],
    isNew: true,
  },
  {
    id: 'workspace',
    label: 'Workspace',
    icon: 'tabler:building',
    to: '/workspace/branding',
    match: [
      'workspace/branding',
      'workspace/roles',
      'workspace/custom-domain',
      'workspace/email',
      'workspace/language',
      'workspace/integrations',
      'workspace/settings',
      'workspace/webhooks',
      'workspace/api-keys',
      'workspace/members',
      'custom-domain',
      'user-roles',
      'email-domain-rules',
      'automations',
      'profile',
    ],
  },
]

/**
 * True when `pathname` belongs to one of the item's `match` prefixes.
 * Multi-segment prefixes (e.g. 'workspace/members') are supported.
 * While the showcase collection is open, only the Portal item is active.
 */
export const isNavItemActive = (item, pathname, isShowcaseOpen) => {
  const path = pathname.replace(/^\/+|\/+$/g, '')

  if (isShowcaseOpen && path.startsWith('collection/')) {
    return Boolean(item.opensShowcase)
  }

  return item.match.some(prefix =>
    prefix === ''
      ? path === ''
      : path === prefix || path.startsWith(`${prefix}/`),
  )
}
